module.exports = __webpack_public_path__ + "static/media/mediterraneo_mototurismo_1.de70e595.jpg";